$(document).ready(function(){

  $('.mobile-nav__link').click(function(){
    var attr_text = $(this).text().trim();
    if(attr_text == 'Products'){
      if($(this).parents('li').find('.mob-nav').hasClass('open') == true)
      {
        $(this).parents('li').find('.mob-nav').hide().removeClass('open');
        $('.txt').removeClass('mobile_txt');
      } 
      else
      {
        $(this).parents('li').find('.mob-nav').show().addClass('open');
         $('.txt').addClass('mobile_txt');
      } 
    }
  });
  
  $(".Products").hover(function(event){
     $('.header-product').show();
   },
    function () {
    $('.header-product').hide();
    }                       
  );

  $(".header-product").hover(function(event){
     $(this).show();
   },
    function () {
    $(this).hide();
    }                       
  );  
});

var modal = document.getElementById("myModal");
var btn = document.getElementById("myBtn");
var span = document.getElementsByClassName("close")[0];
btn.onclick = function() {
  modal.style.display = "block";
}
span.onclick = function() {
  modal.style.display = "none";
}
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}